import produce from 'immer';

export default (data, action) => {
  // ----> Logs
  // console.log('Called faq reducer');
  // console.log(`Called action type ${action.type}`);
  // console.log('Prev state:');
  // console.table(faq);
  // console.log('Action payload:');
  // console.table(action);

  switch (action.type) {
    case 'setSegments':
      return produce(data, draft => {
        draft.segments = action.newSegments;
      });

    default:
      return data;
  }
};
